import { fg } from '@atlaskit/platform-feature-flags';

import type { RecentActivityItem, SearchResultItem } from '../../../common/ui/quick-find/types.tsx';
import {
	getJiraWorkItemKeyFromActivity,
	getJiraWorkItemKeyFromSearchResult,
	normalizeWorkItemKey,
} from '../../../common/ui/quick-find/utils.ts';

const MIN_QUERY_LENGTH = 2;

export const isQueryMatchingActivityKey = (
	query: string,
	item: RecentActivityItem,
): RecentActivityItem | undefined => {
	const itemKey = getJiraWorkItemKeyFromActivity(item);
	if (query.length >= MIN_QUERY_LENGTH && itemKey) {
		const itemKeyFromQuery = fg('search_qf_issue_key_variants')
			? normalizeWorkItemKey(query.trim())
			: query.trim().toLowerCase();

		if (itemKeyFromQuery === itemKey?.toLowerCase()) {
			return item;
		}
	}
	return undefined;
};

export const isQueryMatchingSearchResultKey = (
	query: string,
	item: SearchResultItem,
): SearchResultItem | undefined => {
	const itemKey = getJiraWorkItemKeyFromSearchResult(item);
	if (query.length >= MIN_QUERY_LENGTH && itemKey) {
		const itemKeyFromQuery = fg('search_qf_issue_key_variants')
			? normalizeWorkItemKey(query.trim())
			: query.trim().toLowerCase();

		if (itemKeyFromQuery === itemKey?.toLowerCase()) {
			return item;
		}
	}
	return undefined;
};
